import { createFileRoute } from '@tanstack/react-router';
import { AdminCurriculum } from '../../components/curriculum/AdminCurriculum';
import { useAdmin } from './-context';

export const Route = createFileRoute('/_admin/curriculum')({
  component: CurriculumRoute,
});

function CurriculumRoute() {
  const { curricula, versions, classes, subjects, chapters, topics, subtopics, isLoading } =
    useAdmin();
  return (
    <div className="h-full overflow-auto w-full max-w-[920px] mx-auto px-6 pt-8 pb-[60px]">
      <AdminCurriculum
        curricula={curricula}
        versions={versions}
        classes={classes}
        subjects={subjects}
        chapters={chapters}
        topics={topics}
        subtopics={subtopics}
        isLoading={isLoading}
      />
    </div>
  );
}
